<template>
    <div v-if="configLoaded" class="flex flex_column flex_center md-layout-item margin_horizontal">
        <div class="pageTitle">
            <span class="md-title">{{ $t("management.walbing-referrer.title") }}</span>
        </div>

		<div class="w_40">
			<p v-html="$t('management.walbing-referrer.text', {
				referrerCreditAmount: config.formatted.referrerCreditAmount,
				currency: config.currency
			})"></p>

			<span class="font_bold">{{ $t("management.walbing-referrer.steps.steps.title") }}</span>
			<ol>
				<li v-html="$t('management.walbing-referrer.steps.step1')"></li>
				<li v-html="$t('management.walbing-referrer.steps.step2')"></li>
				<li v-html="$t('management.walbing-referrer.steps.step3', {
					referrerCreditAmount: config.formatted.referrerCreditAmount,
					goalSalesVolumeAmount: config.formatted.goalSalesVolumeAmount,
					currency: config.currency,
					goalCheckDurationInMonths: config.goalCheckDurationInMonths,
			})"></li>
			</ol>

			<p v-html="$t('management.walbing-referrer.steps.ending.text')"></p>

			<div class="light_bg_color base_padding flex">
				<div class="margin_r">
					<div>{{ $t("management.walbing-referrer.infoBox.code.label") }}</div>
					<div>{{ $t("management.walbing-referrer.infoBox.link.label") }}</div>
				</div>
				<div class="font_bold">
					<div>{{ config.invitationCode }}</div>
					<div>{{ config.registrationLink }}</div>
				</div>
			</div>
		</div>

		<div class="w_100 margin_top_l">
			<span class="font_bold">{{ $t("management.walbing-referrer.table.title") }}</span>
			<div class="flex_1">
				<ag-item :rowData="rowData"
						 :columnDefs="columnDefs"
						 v-on:sortChanged="sortChanged"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem";
import {asLocalizedDate} from "@/components/templates/agGrid/formatter/valueFormatters";
import {formatAsMoneyAmount, formatEmptyAsNotAvailable} from "@/common/format";
import {walbingReferrerApi} from "@/common/api/walbingReferrerApi";
import {enumDef} from "@/common/enumDefs";

export default {
    components: {
        AgItem
    },
    data() {
        return {
			config: {
				invitationCode: "",
				registrationLink: "",
				formatted: {
					referrerCreditAmount: "",
					currency: "",
					goalSalesVolumeAmount: "",
					goalCheckDurationInMonths: ""
				}
			},
			configLoaded: false,
            rowData: [],
            columnDefs: [],
			sorting: []
        };
    },
	created() {
		this.loadConfig();
	},
	beforeMount() {
        this.setColumnDef();
        this.getList();
    },
    methods: {
        setColumnDef() {
            this.columnDefs = [
                {
                    headerName: this.$t("common.company"),
                    field: "companyName",
                    sortable: true
                },
                {
                    headerName: this.$t("management.walbing-referrer.table.header.signUpDate"),
                    field: "creationTime",
                    valueFormatter: asLocalizedDate(),
                    sortable: true
                },
                {
                    headerName: this.$t("management.walbing-referrer.table.header.activationDate"),
                    field: "activationTime",
                    valueFormatter: asLocalizedDate( { showEmptyAsNotAvailable: true }),
                    sortable: true
                },
                {
                    headerName: this.$t("management.walbing-referrer.table.header.evaluationDate"),
                    field: "goalCheckDate",
                    valueFormatter: asLocalizedDate({ showEmptyAsNotAvailable: true }),
                    sortable: true
                },
                {
                    headerName: this.$t("management.walbing-referrer.table.header.referralSuccessful"),
                    field: "successful",
                    cellRendererFramework: "BooleanAsIcon",
					cellRendererParams: {
						emptyDefault: "fa-clock-o"
					},
                    sortable: true
                },
                {
                    headerName: this.$t("management.walbing-referrer.table.header.payoutStatus"),
					field: "creditNotePaymentStatus",
					cellRendererFramework: "EnumAsText",
					enumDef: enumDef.creditNotePaymentStatus,
					cellRendererParams: {
						formatParams: {
							showEmptyAsNotAvailable: true
						}
					},
                    sortable: true
                }
            ];
        },
		sortChanged(sortData) {
			this.sorting = sortData;
			this.getList();
		},
        getList() {
			let postData = {
				columns: [],
				filters: [],
				maxResults: 25000, // no pagination for now
				offset: 0,
				sorting: this.sorting
			};

			walbingReferrerApi.inspection.listReferrals(postData)
				.then(res => {
					this.rowData = res.data;
				})
				.catch(this.toast);
        },
		loadConfig() {
			walbingReferrerApi.inspection.getConfig()
				.then(res => {
					this.config = {
						...res,
						invitationCode: formatEmptyAsNotAvailable(res.invitationCode),
						registrationLink: formatEmptyAsNotAvailable(res.registrationLink),
						formatted: {
							referrerCreditAmount: formatAsMoneyAmount(res.referrerCreditAmount, { decimals: 0 }),
							goalSalesVolumeAmount: formatAsMoneyAmount(res.goalSalesVolumeAmount, { decimals: 0 }),
						}
					};
					this.configLoaded = true;
				})
				.catch(this.toast);
		}
    }
};
</script>